import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[tasksApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
        });
    } else {
        console.error(`[tasksApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export default {
    async getTasks(params = {}) {
        try {
            const response = await axiosInstance.get('tasks/', { params });
            return response.data;
        } catch (error) {
            logAndRethrow('GET tasks/', error);
        }
    },

    async getTask(id) {
        try {
            const response = await axiosInstance.get(`tasks/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET tasks/${id}/`, error);
        }
    },

    async createTask(payload) {
        try {
            const response = await axiosInstance.post('tasks/', payload);
            return response.data;
        } catch (error) {
            logAndRethrow('POST tasks/', error);
        }
    },

    async postDone(id) {
        try {
            const response = await axiosInstance.post(`tasks/${id}/done`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST tasks/${id}/done`, error);
        }
    },

    async postDecline(id, reason) {
        try {
            const response = await axiosInstance.post(`tasks/${id}/decline`, { reason });
            return response.data;
        } catch (error) {
            logAndRethrow(`POST tasks/${id}/decline`, error);
        }
    },

    async postReturn(id, reason) {
        try {
            const response = await axiosInstance.post(`tasks/${id}/return`, { reason });
            return response.data;
        } catch (error) {
            logAndRethrow(`POST tasks/${id}/return`, error);
        }
    },

    async postClose(id) {
        try {
            const response = await axiosInstance.post(`tasks/${id}/close`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST tasks/${id}/close`, error);
        }
    },

    async getUrl(url) {
        try {
            let resp;
            if (/^https?:\/\//i.test(url)) {
                resp = await axiosInstance.get(url);
            } else {
                const path = url.startsWith('/') ? url.slice(1) : url;
                resp = await axiosInstance.get(path);
            }
            return resp.data;
        } catch (error) {
            logAndRethrow(`GET ${url}`, error);
        }
    }
};